import { BoxProps } from '@drone-js/core';
import { CrossSellWidgetState, selectUnlockedStateForBanner } from '@cart-js/trip';
import { createSelector, Dispatch } from '@reduxjs/toolkit';
import { ActivitiesCombinedPageTypes, ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { selectPageTypeIdFromBootstrap, setCid, selectUnlockTripSavingsBehavior, selectIsLoggedIn, selectConfigFromBootstrap } from 'store/slice/bootstrap';
import { MapActivitiesStateToShouldRenderCrossSellWrapper } from 'core/context/CrossSellWrapper/withCrossSellWrapper';
import { getPageType } from 'core/messaging/analytics/pages/pageTypeUtils';

export interface UnlockTripSavingsBannerPropsOwnProps {
    outerBoxProps?: BoxProps;
    innerBoxProps?: BoxProps;
}

interface TripStateProps {
    isBannerVisible: boolean;
}

interface ActivitiesStateProps {
    pageTypeId: ActivitiesPageTypes;
}

interface ActivitiesDispatchProps {
    setCid: (cid: number) => void;
}

export type UnlockTripSavingsBannerProps = UnlockTripSavingsBannerPropsOwnProps & TripStateProps & ActivitiesStateProps & ActivitiesDispatchProps;

export const mapTripStateToProps = (state: CrossSellWidgetState): TripStateProps => ({
    isBannerVisible: selectUnlockedStateForBanner(state, 'hasUpcomingBooking', false),
});

export const mapActivitiesStateToShouldRender: MapActivitiesStateToShouldRenderCrossSellWrapper = createSelector(
    selectUnlockTripSavingsBehavior,
    selectIsLoggedIn,
    (isUnlockTripSavingsEnabled, isLoggedIn) => ({
        shouldRender: isUnlockTripSavingsEnabled && isLoggedIn,
    }),
);

export const mapActivitiesStateToProps = createSelector(selectConfigFromBootstrap, selectPageTypeIdFromBootstrap, (config, activitiesPageTypeId): ActivitiesStateProps => {
    const pageTypeId = ActivitiesCombinedPageTypes[activitiesPageTypeId];
    const pageType = getPageType(config.browser, pageTypeId);
    return {
        pageTypeId: pageType,
    };
});

export const mapDispatchToProps = (dispatch: Dispatch): ActivitiesDispatchProps => ({
    setCid: (cid: number) => {
        dispatch(setCid(cid));
    },
});
